// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import skillRunEntity from './entities/skill-run.json';
import skillRunMenu from '../pages/skill-run/menu.json';
import skillRunFullForm from '../pages/skill-run/forms/full.json';
import skillRunContextForm from '../pages/skill-run/forms/context.json';
import skillRunMiniForm from '../pages/skill-run/forms/mini.json';
import skillRunLookupForm from '../pages/skill-run/forms/lookup.json';
import skillRunTableView from '../pages/skill-run/views/table.json';
import skillRunCardsView from '../pages/skill-run/views/cards.json';
import skillRunDashboardView from '../pages/skill-run/views/dashboard.json';

/** Тип запису «Запуск навички» зі сторінками пакета: меню, форми та подання з pages/skill-run/. */
export const skillRunDefinition: IRecordTypeDefinition = {
  ...skillRunEntity,
  views: assembleViewSet({
      table: skillRunTableView,
      cards: skillRunCardsView,
      dashboard: skillRunDashboardView,
  }),
  form: skillRunFullForm,
  forms: { full: skillRunFullForm, context: skillRunContextForm, mini: skillRunMiniForm, lookup: skillRunLookupForm },
  menu: skillRunMenu,
} as IRecordTypeDefinition;
